import React from 'react';
import { ProviderMatchTraining } from '@kyruus/types';
import { FormattedMessage } from '@kyruus/intl';

import {
  ExpertiseSectionContainer,
  ExpertiseSectionTitle,
  ExpertiseList
} from './styles';
import EducationEntry from './education-entry';
import messages from '../../lib/messages';

const Education = ({
  training
}: {
  training: ProviderMatchTraining[];
}): React.ReactElement | null => {
  // do not render if data not present
  if (!training || training.length === 0) {
    return null;
  }

  return (
    <ExpertiseSectionContainer>
      <ExpertiseSectionTitle>
        <FormattedMessage {...messages.educationSectionTitle} />
      </ExpertiseSectionTitle>
      <ExpertiseList>
        {training.map((t, index) => {
          return (
            <EducationEntry
              key={`${t.degree}${t.field_of_study}${t.graduation_year}${t.name}${t.type}${index}`}
              training={t}
            />
          );
        })}
      </ExpertiseList>
    </ExpertiseSectionContainer>
  );
};

export default Education;
